export default __webpack_public_path__ + "static/media/search_icon.2a4f84c8.svg";